module.exports = window.jQuery